import { mapState, mapActions } from "vuex";
import AppInput from "@/components/AppInput";
import { EVENTS } from "@/utils";
export default {
  name: "LTVPerAsinController",
  components: {
    AppInput
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      metricOptions: state => state.customer_insights.metricOptions,
      currentMetricValue: state => state.customer_insights.currentMetricValue
    })
  },
  methods: {
    ...mapActions(["customerInsightsKeyWordListSet"]),
    selectMetric(value) {
      this.$store.dispatch("customerInsightsSetMetric", value);
    }
  }
};